import { getHTML } from "../../services/helper";
import BreadCrumb from "./BreadCrumb";
import "./HeroBreadCrumb.scss";

interface IProps {
    style?: React.CSSProperties;
    content: {
        image?: string;
        header?: string;
        description?: string;
    }
}

const HeroBreadCrumb: React.FC<IProps> = (props: IProps) => {
    return (
        <section id="page-title" className={ props.content.image ? 'has-background' : ''} style={{backgroundImage: `url(${props.content.image})`}}>
            <div className={ 'd-flex ' + (props.content.image ? 'back-drop' : 'bg-secondary')} style={props.style}>
                <div className="container clearfix text-white py-3 my-auto">
                    <div className="row">
                        <div className="col-12 col-md-8 pt-5">
                            <h1>{props.content.header?.toUpperCase()}</h1>
                        </div>
                        <div className="col-12 col-md-8 py-4">
                            <h6 dangerouslySetInnerHTML={getHTML(props.content.description || '')}></h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <BreadCrumb textColor="#FFFFFF" removeBackground={true} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroBreadCrumb;
